import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import GroupCards from '@shared/group-cards';
import { sortGroups } from '@utils/group-utils';
import './details-table-groups-list.scss';

const DetailsTableGroupsList = ({ entity }) => {
  const list = useSelector(state => state.groups.list);

  const groups = useMemo(() => {
    const { group_ids } = entity;
    const filtered = list.filter(group => group_ids.includes(group.id));
    return sortGroups(filtered);
  }, [entity, list]);

  return (
    <div styleName="groups-container">
      {groups.length === 0 &&
        <div styleName="empty-list">No Groups to show</div>
      }
      {groups.length > 0 && <GroupCards groups={groups} />}
    </div>
  );
};

DetailsTableGroupsList.propTypes = {
  entity: PropTypes.object
};

export default DetailsTableGroupsList;
